module.exports = __webpack_public_path__ + "img/red.4a94cb5d.png";